<template>
  <div class="button-title" :class="$mq">
    <BaseButton class="test-button" @click="emitStartTest">
      <i class="nv nv-video-control-play nv-2x nv-fw"/>
      {{ $t("testBBB.startTest") }}
    </BaseButton>
    <BaseButton class="test-button" @click="emitEndTest">
      <i class="nv nv-text-redo nv-2x nv-fw"/>
      {{ $t("testBBB.endTest") }}
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton"

export default {
  name: "testButtons",

  components: {
    BaseButton,
  },

  methods: {
    emitStartTest() {
      this.$emit('start-test')
    },

    emitEndTest() {
      this.$emit('end-test')
    },
  },
}
</script>

<style lang="scss">
@import "../../utilities/variables";

button .nv {
  position: relative;
  top: 4px !important;
}

button i.nv-interface-question-mark {
  position: relative;
  top: -2px !important;
}

div.container i.nv {
  position: relative;
  top: -4px;
}

div.container i.us {
  position: relative;
  top: -5px;
}

.button-title {
  display: flex;
  justify-content: center;
}

.button-title.smartphone {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.test-button {
  font-family: "Unistra A";
  padding: 5px 8px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  vertical-align: middle;

  cursor: pointer;
  letter-spacing: .03em;
  font-size: 1.125rem;
  min-width: 2.375rem;
  width: 14em;

  margin: 0.5rem 0.5rem 0.5rem 0.5rem !important;

  background-color: $button-color-blue;
  color: $text-button-color;

  border-color: transparent;
  line-height: 1.8461538462;
  border-radius: 0px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:hover {
    background-color: darken($button-color-blue, 10%);
    font-weight: 600;
  }
}
</style>
